import { QuickInfoGroup } from '@aibees/elephant/components/quick-info-group';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(QuickInfoGroup)``;
